import { initializeVertex } from "utils/math/geometry/initializeVertex";
import { Graph } from "./types";

export const addUndirectedEdge = (args: {
  graph: Graph;
  nodeA: string;
  nodeB: string;
  weight: number;
}): void => {
  const { graph, nodeA, nodeB, weight } = args;

  initializeVertex({ graph, nodeId: nodeA });
  initializeVertex({ graph, nodeId: nodeB });

  graph[nodeA].push([nodeB, weight]);
  graph[nodeB].push([nodeA, weight]);
};
